import { render, staticRenderFns } from "./is_3_com_mobile.vue?vue&type=template&id=5887f4ea&scoped=true&"
import script from "./is_3_com_mobile.vue?vue&type=script&lang=js&"
export * from "./is_3_com_mobile.vue?vue&type=script&lang=js&"
import style0 from "./is_3_com_mobile.vue?vue&type=style&index=0&id=5887f4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887f4ea",
  null
  
)

export default component.exports